import config from '../../config'

const createTomaUsadosModule = (apiUrl, request = (...args) => fetch(...args)) => {
  const stale = () => Object.assign(new Error('La solicitud pertenece a una vista anterior.'), { code: 'STALE_REQUEST' })
  const resetCompany = (s, id) => {
    s.companyId = id; s.companyGeneration++
    s.fichas = []; s.vendedores = []; s.peritos = []; s.config = { version: 0, valorPano: 175000 }
  }
  const call = async (token, path, options = {}, binary = false) => {
    if (!token) throw Object.assign(new Error('Iniciá sesión para continuar.'), { code: 'UNAUTHENTICATED' })
    const authorization = 'Bearer ' + String(token).replace(/^Bearer\s+/i, '').trim()
    const response = await request(`${apiUrl}/toma-usados${path}`, { ...options, headers: { 'Content-Type': 'application/json', Authorization: authorization } })
    if (binary && response.ok) {
      const mime = response.headers.get('Content-Type').split(';')[0]
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(mime)) throw Error('Tipo de foto inválido.')
      return response.blob()
    }
    const data = await response.json()
    if (!response.ok || data.exito !== 1) throw Object.assign(new Error('No se pudo completar la solicitud.'), { code: data.error || 'TOMA_UNAVAILABLE', status: response.status })
    return data.data === undefined ? data : data.data
  }
  const companyRequest = async (context, kind, run, accept) => {
    const { state, rootState, commit } = context
    commit('beginRequest', kind)
    const token = rootState.token, company = state.companyId, generation = state.companyGeneration,
      access = state.accessGeneration, requestId = state.requests[kind]
    const current = () => token === rootState.token && company === state.companyId &&
      generation === state.companyGeneration && access === state.accessGeneration && requestId === state.requests[kind]
    try {
      const data = await run(token)
      if (!current()) throw stale()
      return accept(data)
    } catch (error) {
      if (!current()) throw stale()
      throw error
    }
  }
  return {
    namespaced: true,
    state: () => ({ authorized: false, ocr: false, actor: { capabilities: [] }, companies: [], branches: [], fichas: [], vendedores: [], peritos: [], config: { version: 0, valorPano: 175000 },
      companyId: null, companyGeneration: 0, accessGeneration: 0, requests: { list: 0, vendors: 0, config: 0, get: 0, extract: 0, peritos: 0, reconditioning: 0 } }),
    mutations: {
      clearAccess (s) { s.accessGeneration++; s.authorized = false; s.ocr = false; s.actor = { capabilities: [] }; s.companies = []; s.branches = []; resetCompany(s, null) },
      selectCompany (s, id) { resetCompany(s, id == null ? null : Number(id)) },
      beginRequest (s, kind) { s.requests = { ...s.requests, [kind]: (s.requests[kind] || 0) + 1 } },
      access (s, d) { s.authorized = true; s.ocr = d.ocr === true; s.actor = d.actor; s.companies = d.companies; s.branches = Array.isArray(d.branches) ? d.branches : [] },
      fichas (s, d) { s.fichas = d }, vendedores (s, d) { s.vendedores = d }, peritos (s, d) { s.peritos = d }, config (s, d) { s.config = d },
      upsert (s, t) { const index = s.fichas.findIndex(f => f.id === t.id); if (index < 0) s.fichas.unshift(t); else s.fichas.splice(index, 1, t) },
      removeFicha (s, id) { s.fichas = s.fichas.filter(t => Number(t.id) !== Number(id)) }
    },
    actions: {
      async extract (context, payload) {
        const modo = payload.modo || 'crear'
        const capability = modo === 'contraMec' ? 'mec' : 'crear'
        if (!context.state.authorized || !context.state.ocr || !context.state.actor.capabilities.includes(capability) || context.state.companyId !== Number(payload.empresa_id)) throw stale()
        return companyRequest(context, 'extract', token => call(token, '/extract', { method: 'POST', body: JSON.stringify(payload) }), d => d)
      },
      async loadAccess ({ rootState, state, commit }) {
        commit('clearAccess')
        const token = rootState.token, generation = state.accessGeneration, companyGeneration = state.companyGeneration
        const current = () => token === rootState.token && generation === state.accessGeneration && companyGeneration === state.companyGeneration
        let d
        try { d = await call(token, '/access') }
        catch (error) { if (!current()) throw stale(); throw error }
        if (!current()) throw stale()
        const branches = d.branches === undefined ? [] : d.branches
        if (d.permission !== '/toma-usados' || !d.actor || !Number.isInteger(d.actor.id) || d.actor.id < 1 || typeof d.actor.nombre !== 'string' ||
            !Array.isArray(d.actor.capabilities) || !d.actor.capabilities.length || d.actor.capabilities.some(c => typeof c !== 'string') ||
            !Array.isArray(d.companies) || !d.companies.length || d.companies.some(c => !Number.isInteger(c.id) || c.id < 1 || typeof c.nombre !== 'string') ||
            !Array.isArray(branches) || branches.some(b => !Number.isInteger(b.id) || b.id < 1 || typeof b.nombre !== 'string')) throw Error('No se pudo verificar el acceso a Toma de usados.')
        d.branches = branches
        commit('access', d); return d
      },
      async list (context, { empresa_id, offset = 0 }) {
        const { state, commit } = context, company = Number(empresa_id)
        if (state.companyId !== company) {
          if (offset) throw stale()
          commit('selectCompany', company)
        }
        return companyRequest(context, 'list', token => call(token, `?${new URLSearchParams({ empresa_id: company, offset, limit: 100 })}`), d => {
          if (!Array.isArray(d) || d.some(t => Number(t.empresa_id) !== company)) throw Error('Listado inválido.')
          if (!offset) commit('fichas', d)
          else d.forEach(t => commit('upsert', t))
          return d
        })
      },
      async vendors (context, empresa_id) {
        if (context.state.companyId !== Number(empresa_id)) throw stale()
        return companyRequest(context, 'vendors', token => call(token, `/vendedores?${new URLSearchParams({ empresa_id })}`), d => {
          if (!Array.isArray(d)) throw Error('Vendedores no disponibles.')
          context.commit('vendedores', d); return d
        })
      },
      async config (context, empresa_id) {
        if (context.state.companyId !== Number(empresa_id)) throw stale()
        return companyRequest(context, 'config', token => call(token, `/config?${new URLSearchParams({ empresa_id })}`), d => { context.commit('config', d); return d })
      },
      async peritos (context, { empresa_id }) {
        if (context.state.companyId !== Number(empresa_id)) throw stale()
        return companyRequest(context, 'peritos', token => call(token, `/peritos?${new URLSearchParams({ empresa_id })}`), d => {
          if (!Array.isArray(d) || d.some(p => !Number.isInteger(p.id) || p.id < 1 || typeof p.nombre !== 'string' ||
              !['mec', 'chapa'].includes(p.tipo) || ![1, 2].includes(Number(p.sucursal)) || typeof p.activo !== 'boolean')) throw Error('Personal de peritaje inválido.')
          context.commit('peritos', d); return d
        })
      },
      async saveConfig ({ rootState, commit }, payload) { const d = await call(rootState.token, '/config', { method: 'PUT', body: JSON.stringify(payload) }); commit('config', d); return d },
      async get (context, id) {
        return companyRequest(context, 'get', token => call(token, `/${id}`), d => {
          if (Number(d.empresa_id) !== context.state.companyId) throw Error('Ficha de otra empresa.')
          context.commit('upsert', d); return d
        })
      },
      async remove ({ rootState, commit }, { id, empresa_id, patente }) {
        const requestedId = Number(id)
        if (!Number.isSafeInteger(requestedId) || requestedId < 1) throw Error('Ficha inválida.')
        const query = new URLSearchParams({ empresa_id, patente: patente == null ? '' : patente })
        const d = await call(rootState.token, `/${requestedId}?${query}`, { method: 'DELETE' })
        if (!d || Number(d.id) !== requestedId || d.eliminada !== true) throw Error('Respuesta de eliminación inválida.')
        commit('removeFicha', requestedId)
        return d
      },
      async reconditioning (context, id) {
        const requestedId = Number(id), company = Number(context.state.companyId)
        if (!Number.isSafeInteger(requestedId) || requestedId < 1 || !Number.isSafeInteger(company) || company < 1) throw stale()
        return companyRequest(context, `reconditioning:${requestedId}`, token => call(token, `/${requestedId}/reacondicionamiento`, { method: 'GET' }), d => {
          if (!d || typeof d !== 'object' || Number(d.fichaId) !== requestedId || Number(d.empresa_id) !== company ||
              !Array.isArray(d.trabajos) || !['encontrado', 'no_encontrado', 'ambiguo'].includes(d.vinculo) || !Array.isArray(d.ordenes)) {
            throw Error('Respuesta de reacondicionamiento inválida.')
          }
          return d
        })
      },
      async create ({ rootState, commit }, payload) { const d = await call(rootState.token, '', { method: 'POST', body: JSON.stringify(payload) }); commit('upsert', d); return d },
      async createOutOfHours ({ rootState, commit }, payload) { const d = await call(rootState.token, '/fuera-horario', { method: 'POST', body: JSON.stringify(payload) }); commit('upsert', d); return d },
      async availability ({ rootState }, query) {
        const params = new URLSearchParams()
        for (const [key, value] of Object.entries(query || {})) if (value !== undefined && value !== null && value !== '') params.set(key, value)
        return call(rootState.token, `/disponibilidad?${params}`, { method: 'GET' })
      },
      async action ({ rootState, commit }, { id, ...payload }) { const d = await call(rootState.token, `/${id}/actions`, { method: 'POST', body: JSON.stringify(payload) }); commit('upsert', d); return d },
      async upload ({ rootState, commit }, { id, ...payload }) { const d = await call(rootState.token, `/${id}/fotos`, { method: 'POST', body: JSON.stringify(payload) }); commit('upsert', d.ficha); return d },
      async uploadSellerPhotos ({ rootState, commit }, { id, ...payload }) { const d = await call(rootState.token, `/${id}/fotos-vendedor`, { method: 'POST', body: JSON.stringify(payload) }); commit('upsert', d.ficha); return d },
      async photo ({ rootState }, { id, photoId }) { return call(rootState.token, `/${id}/fotos/${photoId}`, {}, true) }
    }
  }
}
export default createTomaUsadosModule(config.API_URL)
